import offerwall from "./offerwall";

export const greenp = {
    offerwall,
};

export default greenp;
